import "./Footer.scss";
import { FaFacebook } from "react-icons/fa";

export default function Footer() {
    const currentYear = new Date().getFullYear();
    return (
        <footer className='footerFormat'>

            <div className='footerFormat'>
                <p>
                    Copyright &copy; {currentYear} Jasmine Rhose Foundation
                </p>

                {/* Facebook Link  */}
                <p className="footerLink" >
                    <a
                        href="https://www.facebook.com/jasminerhosefoundation/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="facebookContainer"
                    >
                        <FaFacebook className="facebookIcon" />
                        <span>Follow us on Facebook</span>
                    </a>
                </p>
            </div>
        </footer>
    )

}